<div class="sidebar flex flex_column">
  <ng-content select="[sidebar-top-content]"></ng-content>
  <div class="sections flex flex_column">
    @for (group of navigation; track group; let groupIdx = $index) {
      <ul class="flex flex_column">
        @for (link of group; track link; let idx = $index) {
          <li>
            @if (link.isButton) {
              <yrx-dropout-point [underlined]="group.length-1 !== idx" (press)="link?.callback?.()" [icon]="link.icon" [iconStroked]="link.iconStroked">
                <span>{{link.name}}</span>
              </yrx-dropout-point>
            } @else {
              <yrx-dropout-point [underlined]="group.length-1 !== idx && activeIndex-1 !== getLinkIndex(groupIdx, idx)" [link]="link.link" [icon]="link.icon" [iconStroked]="link.iconStroked">
                <span>{{link.name}}</span>
              </yrx-dropout-point>
            }
          </li>
        }
      </ul>
      @if (navigation.length-1 !== groupIdx) {
        <yrx-spacing type="S"></yrx-spacing>
      }
    }
  </div>
  <ng-content select="[sidebar-bottom-content]"></ng-content>
</div>
